<template>
  <v-container
    style="max-width: 750px;"
  >
    <h2>
      Welcome
    </h2>

    <v-divider class="mt-3 mb-8" />

    <div>
      <p>
        Dear Coaches,
      </p>

      <p>
        Welcome to the Global Coach Group (GCG). We are here for you,
        to provide an active community of leading coaches to collaborate and
        share best practices to grow better together. With our joint efforts to Lead for Good,
        we can change the world of leadership.
      </p>

      <p>
        Leveraging our joint collective coaching expertise and GCG’s highly effective
        360 Feedforward Coaching process catalyzed with technology,
        we focus on the global top 2000 organizations.
        With our coaches we support aspiring and high performing leaders
        across organizations to effectively transform their leadership,
        engage their teams and improve the organizational culture for
        a better world of work.
      </p>

      <p>
        We will do this by offering our clients a structured,
        yet bespoke and efficient coaching process augmented by technology,
        in multiple languages across the globe.
        Our approach in coaching has proven to achieve measurable results for
        95% of leaders involving coworkers in their development.
        This approach has been designed for and used by over a million
        leaders in more than 100 countries.
      </p>

      <p>
        Technology will continue to drive the future of learning and coaching.
        In our collaboration with various multinationals our highly effective
        Global Coach Platform has proven to be invaluable as it significantly
        improves efficiency, transparency and accountability.
        This in turn accelerates results for leaders and engagement of coworkers,
        while providing more time for coaches to focus on supporting
        leaders in the coaching process while the Global Coach Platform takes care of all the rest.
      </p>

      <p>
        This successful GCG technology is currently being prepared for roll out to
        our GCG network of coaches. You will get a sneak peek of this very soon.
      </p>

      <p>
        Though 2020 has been a challenging year for coaches and leaders alike
        we have seen that our coaches using our Global Coach Platform helped
        leaders not just survive but thrive leading and engaging their often
        remote teams.
      </p>

      <p>
        I look forward to speaking with you soon.
      </p>

      <div>
        <div>
          Kind regards,
        </div>
        <div>
          Will Linssen
        </div>
        <div>
          CEO of Global Coach Group
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
export default {
  name: 'MessageFromWill',
};
</script>
